import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';

import { fetchKnmSupervisionTypes } from 'APIPackage/CatalogsModule/services/knmSupervisionTypesApi';
import { IKnmSupervisionType } from 'APIPackage/CatalogsModule/interfaces/IKnmSupervisionType';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export interface ISupervisionTypeSelectOption extends IKnmSupervisionType {
  label: ISelectOption['label'];
  value: IKnmSupervisionType['id'];
}

export function useKnmSupervisionTypes() {
  const isMounted = useMountedState();
  const [supervisionTypes, setSupervisionTypes] = useState<Array<IKnmSupervisionType>>([]);
  const [supervisionTypesSelectOptions, setSupervisionTypesSelectOptions] = useState<
    Array<ISupervisionTypeSelectOption>
  >([]);

  const refresh = useCallback(async () => {
    try {
      const types = await fetchKnmSupervisionTypes(true);

      isMounted() && setSupervisionTypes(types);
    } catch (e) {
      //
    }
  }, [isMounted]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    const options: ISupervisionTypeSelectOption[] = supervisionTypes.map(type => ({
      ...type,
      label: type.name,
      value: type.id,
    }));

    setSupervisionTypesSelectOptions(options);
  }, [supervisionTypes]);

  return { refresh, supervisionTypes, supervisionTypesSelectOptions };
}
